import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Sparkles, ArrowRight } from 'lucide-react'

export default function CTASection() {
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-synth-900/30 via-void-950 to-signal-900/20" />
      
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-synth-600/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-signal-600/10 rounded-full blur-3xl" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-synth-900/50 border border-synth-700/50 text-synth-300 text-sm font-medium mb-6">
            <Sparkles className="w-4 h-4" />
            Building Trust in the Singularity, One Device at a Time
          </span>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-void-50 mb-6">
            Ready to Run{' '}
            <span className="text-gradient">Governed AI?</span>
          </h2>

          <p className="text-lg md:text-xl text-void-400 mb-10 max-w-2xl mx-auto">
            Get a Scrambler, integrate with 23Controls™, or just talk to our team about
            what you're trying to do. We'll point you at what's real today.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/products" className="btn-primary flex items-center gap-2 text-lg px-8 py-4">
              Explore Products
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link to="/support/contact/sales" className="btn-secondary flex items-center gap-2 text-lg px-8 py-4">
              Talk to Sales
            </Link>
          </div>

          <p className="mt-6 text-void-500 text-sm">
            Affordable · Transparent · Built to protect your data
          </p>
        </motion.div>
      </div>
    </section>
  )
}
